export enum ButtonTheme {
  Error = "Error",
  Highlight = "Highlight",
  HighlightOutline = "HighlightOutline",
  Mauve = "Mauve",
  Primary = "Primary",
  Separator = "Separator",
}
